import { useQuery } from '@tanstack/react-query'
import { apiBase } from '~utils/base-url'
import { useFetch } from '~utils/fetch-request'

export type GetDocumentRes = {
  signedUrl: string
}

interface Props {
  documentId?: string
  attachment?: boolean
}

export function useGetDocument({ documentId, attachment }: Props) {
  const fetchRequest = useFetch<GetDocumentRes>()

  return useQuery({
    queryKey: ['/files', documentId, attachment],
    queryFn: async () =>
      await fetchRequest(
        `${apiBase()}/files/${documentId}?${attachment ? 'attachment=true' : ''}`,
      ),
    enabled: false,
  })
}
